import { IIcon } from '../../model/icon';

export const menuDown: IIcon = {
  id: `MENU_DOWN`,
  svg: `<path fill="#000" d="M5.83 8.33L10 12.5l4.17-4.17H5.83z" />`
};
